import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { supabase } from "@/lib/supabase";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function VerifyEmail() {
  const [cooldown, setCooldown] = useState(30);
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");
  const navigate = useNavigate();

  useEffect(() => {
    if (cooldown > 0) {
      const timer = setInterval(() => {
        setCooldown((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [cooldown]);

  const resendEmail = async () => {
    if (!email) return;

    setLoading(true);

    const { error } = await supabase.auth.resend({
      type: "signup",
      email,
    });

    if (error) {
      toast.error("Error al reenviar", { description: error.message });
    } else {
      toast.success("Correo reenviado", {
        description: "Revisa tu bandeja o carpeta de spam",
      });
      setCooldown(30); // reinicia cooldown
    }

    setLoading(false);
  };

  if (!email) {
    return (
      <div className="flex items-center justify-center min-h-screen text-center px-4">
        <p className="text-muted-foreground">
          No se proporcionó un correo válido.
        </p>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen px-4 bg-muted">
      <Card className="w-full max-w-md shadow">
        <CardHeader>
          <CardTitle className="text-center text-2xl">
            Confirma tu correo
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4 text-center">
          <p>
            Te hemos enviado un enlace de confirmación a{" "}
            <strong>{email}</strong>. Revisa tu bandeja o carpeta de spam.
          </p>

          {cooldown > 0 ? (
            <p className="text-sm text-muted-foreground">
              Puedes volver a solicitar el correo en{" "}
              <strong>{cooldown}s</strong>
            </p>
          ) : (
            <Button onClick={resendEmail} disabled={loading}>
              {loading ? "Reenviando..." : "Reenviar correo"}
            </Button>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
